import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";
import { AggregatesModule } from "@tylertech/aggregates-module";
import { ChartJsContainerComponent } from "@tylertech/chart-js";
import { ChartingModule } from "@tylertech/charting-module";
import { CommandsModule } from "@tylertech/commands-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CoreModule } from "@tylertech/core-module";
import { CustomViewModule } from "@tylertech/custom-view";
import { InfoCardModule } from "@tylertech/info-card-module";
import { IntentsModule } from "@tylertech/intents-module";
import { LgdCheckboxModule, LgdRadioGroupModule, LgdSelectModule, LgdTextModule } from "@tylertech/lgd-reactive-forms";
import { MetadataModule } from "@tylertech/metadata-module";
import { SearchModule } from "@tylertech/search-module";
import
{
    AccountBudgetRecapDialogComponent,
    AccountBudgetRecapTableComponent,
    AccountDetailCardComponent,
    AccountDetailDialogComponent,
    AccountDetailPieChartComponent,
    AccountHorizontalBarChartComponent,
    AnnualExpenditureChartComponent,
    BudgetByDepartmentChartComponent,
    BudgetRecapChartComponent,
    NextYearBudgetRecapChartComponent,
    CashBalanceByFundChartComponent,
    DepartmentsNearingBudgetLimitSmartCardComponent,
    FiscalActivityChartComponent,
    JournalEntryReceiptDialogComponent,
    JournalEntryTemplateDialogComponent,
    MonthlyActivityChartComponent,
    MonthlyRevenueChartComponent,
    MonthlySpendingChartComponent,
    ViewOnlyInfoCardDialogComponent,
} from "./components";
import
{
    AccountDetailDrilldownService,
    AccountLookupService,
    BudgetAdjustmentService,
    BudgetCodeFiscalService,
    BudgetFundService,
    BudgetService,
    FiscalService,
    FundLookupService,
    GLAccountService,
    GLBatchReceiptPayerLookupService,
    GLBatchReceiptService,
    GLDepositService,
    GeneralLedgerDialogService,
    GlModuleControlService,
    JournalEntryService,
    JournalTemplateService,
    SegmentService,
} from "./services";

const angularModules = [
    CommonModule,
    FlexModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule
];

const angularMaterialModules = [
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatDividerModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatTableModule,
    MatTooltipModule,
];

const lgdModules = [
    CustomViewModule.withComponents(
        /* eslint-disable @typescript-eslint/naming-convention */
        {
            "general-ledger-annual-expenditure-chart": AnnualExpenditureChartComponent,
            "general-ledger-budget-by-department-chart": BudgetByDepartmentChartComponent,
            "general-ledger-budget-recap-chart": BudgetRecapChartComponent,
            "general-ledger-next-year-budget-recap-chart": NextYearBudgetRecapChartComponent,
            "general-ledger-fiscal-activity-recap": FiscalActivityChartComponent,
            "general-ledger-month-activity-recap": MonthlyActivityChartComponent,
            "general-ledger-monthly-revenue-chart": MonthlyRevenueChartComponent,
            "general-ledger-monthly-spending-chart": MonthlySpendingChartComponent,
            "general-ledger-cash-balance-by-fund-chart": CashBalanceByFundChartComponent,
            "general-ledger-departments-nearing-budget-limit": DepartmentsNearingBudgetLimitSmartCardComponent,
        }
        /* eslint-enable @typescript-eslint/naming-convention */
    ),
    ChartJsContainerComponent,
    ChartingModule,
    CommonComponentsModule,
    CoreModule,
    CommandsModule,
    IntentsModule,
    AggregatesModule,
    LgdCheckboxModule,
    LgdRadioGroupModule,
    LgdSelectModule,
    LgdTextModule,
    MetadataModule,
    SearchModule,
    InfoCardModule
];

const components = [
    AccountDetailPieChartComponent,
    AccountHorizontalBarChartComponent,
    AccountDetailCardComponent,
    MonthlySpendingChartComponent,
    AnnualExpenditureChartComponent,
    DepartmentsNearingBudgetLimitSmartCardComponent,
    CashBalanceByFundChartComponent,
    MonthlyRevenueChartComponent,
    BudgetRecapChartComponent,
    NextYearBudgetRecapChartComponent,
    BudgetByDepartmentChartComponent,
    MonthlyActivityChartComponent,
    FiscalActivityChartComponent,
    AccountBudgetRecapDialogComponent,
    AccountBudgetRecapTableComponent,
    AccountDetailDialogComponent,
    ViewOnlyInfoCardDialogComponent,
    JournalEntryReceiptDialogComponent,
    JournalEntryTemplateDialogComponent,
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules
    ],
    declarations: components,
    exports: components,
    providers: [
        GeneralLedgerDialogService,
        SegmentService,
        GlModuleControlService,
        JournalTemplateService,
        JournalEntryService,
        GLDepositService,
        FundLookupService,
        FiscalService,
        BudgetFundService,
        BudgetCodeFiscalService,
        BudgetAdjustmentService,
        GLBatchReceiptPayerLookupService,
        GLBatchReceiptService,
        AccountLookupService,
        AccountDetailDrilldownService,
        GLAccountService,
        BudgetService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GeneralLedgerModule { }

